import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@shopify/polaris';
import './styles.scss';
import { Images } from './Images';

class Feedback extends Component {
    handleShowFeedbackBody = () => {
        const fbBodyEl = document.getElementById('yta-feedback');
        if (fbBodyEl.offsetLeft === 0) {
            var pos = 0;
            var intervalTimeoutt = setInterval(frame, 1);
            function frame() {
                if (pos === -260) {
                    clearInterval(intervalTimeoutt);
                } else {
                    pos -= 5;
                    fbBodyEl.style.left = pos + 'px';
                }
            }
        } else {
            var pos = -260;
            var intervalTimeoutt = setInterval(frame, 1);
            function frame() {
                if (pos === 0) {
                    clearInterval(intervalTimeoutt);
                } else {
                    pos += 5;
                    fbBodyEl.style.left = pos + 'px';
                }
            }
        }
    };
    render() {
        const { app_name, review_url, support_url, contact_url } = this.props;
        return (
            <div id="yta-feedback" className="yta-feedback">
                <div className="yta-feedback-body">
                    <div className="feedback-headline">What do you think about app?</div>
                    <a atl={app_name} href={review_url} target="_blank">
                        <div className="yta-fb-body-item">
                            <img alt={app_name} src={Images.love_it}></img>
                            <div className="yta-fb-body-title">Love it</div>
                        </div>
                    </a>
                    <a atl={app_name} href={support_url} target="_blank">
                        <div className="yta-fb-body-item">
                            <img alt={app_name} src={Images.confused}></img>
                            <div className="yta-fb-body-title">Confusing</div>
                        </div>
                    </a>
                    <a atl={app_name} href={contact_url} target="_blank">
                        <div className="yta-fb-body-item">
                            <img alt={app_name} src={Images.frustrated}></img>
                            <div className="yta-fb-body-title">Frustating</div>
                        </div>
                    </a>
                    <div className="yta-fb-body-item">
                        <div className="yta-fb-body-title">
                            or...{' '}
                            <span className="send-us">
                                <a atl={app_name} href={contact_url} target="_blank">
                                    send us feedback
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="yta-feedback-head" onClick={() => this.handleShowFeedbackBody()}>
                    <div className="yta-feedback-head-main">
                        <div className="feedback-icon"></div>
                        <div className="feedback-text noselect">Feedback</div>
                    </div>
                </div>
            </div>
        );
    }
}

Feedback.propTypes = {
    app_name: PropTypes.string.isRequired,
    review_url: PropTypes.string.isRequired,
    support_url: PropTypes.string.isRequired,
    contact_url: PropTypes.string.isRequired,
};

export default Feedback;
